export function routes($stateProvider) {
    $stateProvider
        .state('app.crm.vendedores', {
        url: '/vendedores',
        abstract: true
    })
        .state('app.crm.vendedores.list', {
        url: '?{page:int}&{items:int}&{state:int}&order&sort&filter',
        title: 'Vendedores',
        template: '<crm-vendedores-list-view></crm-vendedores-list-view>',
        role: ['crmListarTodosVendedores'],
        params: {
            page: {
                value: 1,
                dynamic: true
            },
            limit: {
                value: 20,
                dynamic: true
            },
            sortBy: {
                array: true,
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    })
        .state('app.crm.vendedores.details', {
        url: '/{id:int}',
        title: 'Vendedor',
        template: '<crm-vendedores-details-view></crm-vendedores-details-view>',
        params: {
            page: {
                value: 1,
                dynamic: true
            },
            limit: {
                value: 20,
                dynamic: true
            },
            sortBy: {
                array: true,
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    });
}
routes.$inject = ['$stateProvider'];
